var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.data('id');
                return { id: rowId, $el: $rowElem };
            },
            actions: [{
                name: 'Details ansehen',
                classNames: 'dropdown-item',
                iconClass: 'bi-eye',
                onClick: this.openInvitationDetails,
            // }, {
            //     name: 'Position löschen',
            //     classNames: 'dropdown-item text-danger',
            //     iconClass: 'bi-trash',
            //     onClick: this.deletePosition,
            }],
        });
    },

    events: [{
        name: 'click',
        el(component) { return component.el.querySelectorAll('.btn-context-click'); },
        handler(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var rowEl = $(ev.target).closest(this.selector);
            this.menu.open(rowEl, ev);
        }
    }],

    methods: {
        openInvitationDetails(row) {
            if (row.id) {
                slidein.openUrl('/Devis/Evaluation/InvitationDetailSlideIn/' + row.id);
            }
        },
    },

}
